module.exports = __webpack_public_path__ + "img/aiCard.f358ca90.png";